import React from 'react';

import {AppEventsLogger} from 'react-native-fbsdk-next';

import {RegiaoDTO} from '../../../dtos/RegiaoDTO';

import {NativeStackScreenProps} from 'react-native-screens/lib/typescript/native-stack/types';
import {RootStackParamList} from '../../../dtos/RoutesDTO';
import {RegionsList} from '../../../components/shared/RegionsList';

type ScreenProps = NativeStackScreenProps<RootStackParamList, 'MapLocation'>;

export function MapLocation({navigation, route}: ScreenProps) {
  async function oneCityAction(item: RegiaoDTO) {
    if (route.params?.callback) {
      route.params.callback({
        city: item.cidades[0].cidade,
        state: item._id,
      });
    }
    navigation.goBack();
    AppEventsLogger.logEvent('clique_regiao_direta_mapa', {
      cidade: item.cidades[0].cidade,
      regiao: JSON.stringify(item.cidades[0].regioes),
    });
  }

  async function manyCitiesAction(item: RegiaoDTO) {
    navigation.push('SubRegionsMap', {
      data: item,
      tipo: route.params.tipo,
      callback: route.params?.callback, // Passa o callback para a próxima tela
    });
    AppEventsLogger.logEvent('clique_regiao_mapa', {
      regiao: JSON.stringify(item.cidades[0].regioes),
    });
  }

  return (
    <RegionsList
      oneCityAction={oneCityAction}
      manyCitiesAction={manyCitiesAction}
      tipo={route.params.tipo}
    />
  );
}
